const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.addRole.hideModal()
  }
}

export default OnEscape
